import { render, staticRenderFns } from "./ShareTehilimDay.vue?vue&type=template&id=6e9cc180&scoped=true&"
import script from "./ShareTehilimDay.vue?vue&type=script&lang=js&"
export * from "./ShareTehilimDay.vue?vue&type=script&lang=js&"
import style0 from "./ShareTehilimDay.vue?vue&type=style&index=0&id=6e9cc180&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9cc180",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VRow})
